import React, { useId } from "react";
import styles from "./ToggleSwitch.module.scss";

interface ToggleSwitchProps {
  label: string;
  required?: boolean;
  setValue: (value: boolean) => void;
  value: boolean;
  describedById?: string;
  disabled?: boolean;
}

export const ToggleSwitch = ({
  label,
  required = false,
  setValue,
  value,
  describedById,
  disabled = false,
}: ToggleSwitchProps) => {
  const id = useId();

  return (
    <div className={styles["toggle-container"]}>
      <label className={styles["label-wrap"]} htmlFor={id}>
        <input
          id={id}
          type="checkbox"
          className={styles.checkbox}
          checked={value}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              setValue(!value);
            }
          }}
          onChange={(e) => setValue(e.target.checked)}
          aria-required={required || undefined}
          aria-describedby={describedById}
          disabled={disabled}
        />
        <span className={styles.track} aria-hidden="true">
          <span className={styles.thumb} />
        </span>
        <span className={styles.text}>
          {label}
          {required ? " *" : ""}
        </span>
      </label>
    </div>
  );
};
